function drawingUrl(src: string, prefix: string) {
    return `${prefix}${encodeURI(src)}?t=${Date.now()}`;
}

export default drawingUrl;
